import { render, staticRenderFns } from "./vsCollapseItem.vue?vue&type=template&id=7cc2f0e9&"
import script from "./vsCollapseItem.vue?vue&type=script&lang=js&"
export * from "./vsCollapseItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vsCollapseItem.vue"
export default component.exports